import React from "react";
import Employment from "../../organisms/Employment";
import useStepPersistence from "../../Hooks/useStepPersistience";
const EmploymentContainer = ({ formData, setFormStep, user, errors, loading, }) => {
    const [data, handleChange, handleSubmit] = useStepPersistence({
        is_employed: null,
        employer_title: "",
        employer_last_name: "",
        employer_phone: "",
        employer_email: "",
        was_employed: null,
        unemployment_date: "",
        known_new_income: null,
        comment: "",
    }, formData, setFormStep);
    return (React.createElement(Employment, { onSubmit: handleSubmit, onChange: handleChange, data: Object.assign(Object.assign({}, formData), data), user: user, errors: errors, loading: loading }));
};
export default EmploymentContainer;
